<template>
  <div v-if="bodyShow">
    <div class="pc">
      <h1>PC端自我对话操作流程</h1>
      <ul>
        <li>
          <h2><span>1</span>点击复制下方链接</h2>
          <h3>
          <span class="text-ellipsis">{{url}}</span>
            <a class="into_project" v-clipboard:copy="url" v-clipboard:success="onCopy" v-clipboard:error="onError">
              复制
            </a>
        </h3>
        </li>
        <li>
          <h2><span>2</span>粘贴至浏览器并回车键加载</h2>
          <div class="lj">
            <span class="text-ellipsis">{{url}}</span>
          </div>
        </li>
        <li>
          <h2><span>3</span>用自己的微信，扫描加载出的二维码并授权登录</h2>
          <img src="@a/dio_pc_ewm.png" alt="" />
        </li>
        <li>
          <h2><span>4</span>在PC端完成自我对话即可</h2>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {
  isMain
} from '@/utils/tools'
import {
  shareCon
} from "@/utils/wxconfig"
export default {
  data() {
      return {
        bodyShow: true,
        url: ''
      }
    },
    methods: {
      // 复制成功
      onCopy(e) {
        this.$toast('复制成功!');
      },
      // 复制失败
      onError(e) {
        alert("失败");
      },
      pullData() {
        let fullPath = this.$route.query.fullPath;
        this.url = isMain() ? 'https://open.xjy.cn/main' + fullPath : 'https://open.xjy.cn/test' + fullPath;
      }
    },
    created() {
      this.pullData();
      shareCon("course", this);
    }
}
</script>
<style lang="scss" scope>
.pc {
  padding: 40px 30px;
  h1 {
    font-size: 36px;
    color: #333;
    text-align: center;
    font-weight: bold;
  }
  ul li {
    margin-top: 40px;
    h2 {
      font-size: 32px;
      color: #F57F27;
      line-height: 55px;
      span {
        width: 31px;
        height: 31px;
        background: rgba(245, 127, 23, 1);
        border-radius: 50%;
        display: inline-block;
        line-height: 30px;
        font-size: 24px;
        color: #fff;
        text-align: center;
        vertical-align: middle;
        margin-right: 30px;
      }
    }
    h3 {
      font-size: 26px;
      color: #333;
      margin-top: 10px;
      margin-left: 55px;
      span {
        display: inline-block;
        width: 500px;
        margin-right: 20px;
      }
      a {
        width:60px;
        height:32px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(204,204,204,1);
        border-radius:4px;
        display: inline-block;
        font-size: 20px;
        color: #666;
        line-height: 32px;
        text-align: center;
        vertical-align: super;
      }
    }
    .lj {
      background-image: url('../../../assets/dio_pc_bg.png');
      background-size: cover;
      width: 583px;
      height: 120px;
      margin-top: 10px;
      margin-left: 55px;
      padding-top: 70px;
      padding-left: 115px;
      span {
        display: inline-block;
        width: 446px;
        color: #fff;
        font-size: 22px;
      }
    }
    img {
       width: 343px;
      height: 403px;
      margin-top: 10px;
      margin-left: 55px;
    }
  }
}
</style>
